/* Wine structure (BL) — Boolland custom.
   Arms the scales (fill at zero) and releases them when the block
   scrolls into view. Without JS, with data-static, or under
   prefers-reduced-motion the block simply shows its final state. */
(function () {
  if (customElements.get('bl-wine-structure')) return;

  class BlWineStructure extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-static')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      this.classList.add('bl-ws--armed');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          requestAnimationFrame(() => this.classList.add('bl-ws--play'));
        });
      }, { threshold: 0.4 });

      observer.observe(this);
    }
  }

  customElements.define('bl-wine-structure', BlWineStructure);
})();
